
/* injects from baggage-loader */

import React from 'react';
import { connect } from "react-redux";
import { cashoutedBets, checkCashoutTicket, saveTimer, ticketScan, toggleTimerInPopup } from '../../../actions/ui';
import { t } from '../../../helpers/translator';
import { UIMixin } from '../../../mixins/uiMixin';
class ConfirmTicketClosePopup extends React.Component {
    constructor (props) {
        super(props);

        this.deleteTickets = this.deleteTickets.bind(this);
        this.cancelButton = this.cancelButton.bind(this);
    }
    deleteTickets () {
        this.props.dispatch(ticketScan(null, false));
        this.props.dispatch(cashoutedBets(null, false));
        this.props.dispatch(checkCashoutTicket(null));
        this.props.dispatch(toggleTimerInPopup(false));
        this.props.dispatch(saveTimer(null));
        this.props.closePopup()();
    }
    cancelButton () {
        this.props.closePopup()();
        this.props.openPopup("multipleTicketsPopup")();
    }
    render () {
        return (
            <>
                <div className="ticket-results-view-p">
                    <p>{t(`Are you sure you want  to delete scanned tickets?`)}</p>
                    <div className="buttons-view-w-t">
                        <ul>
                            <li>
                                <div className="separator-box-buttons-m">
                                    <button className="button-view-normal-m"
                                        onClick={() => this.deleteTickets()}>
                                        {t("Yes")}
                                    </button>
                                </div>
                            </li>
                            <li>
                                <div className="separator-box-buttons-m">
                                    <button className="button-view-normal-m trans-m"
                                        onClick={() => this.cancelButton()}>
                                        {t("Cancel")}
                                    </button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        tickets: state.uiState.tickets
    };
};

export default connect(mapStateToProps)(UIMixin({Component: ConfirmTicketClosePopup}));